import React from "react";

// Components
import EditPhysicalDamageForm from "../../components/EditPhysicalDamageForm";
import SectionWrapper from "../../components/SectionWrapper/SectionWrapper";

const EditPhysicalDamagePage = () => {
  return (
    <SectionWrapper>
      <EditPhysicalDamageForm />
    </SectionWrapper>
  );
};

export default EditPhysicalDamagePage;
